// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* { box-sizing: border-box; padding: 0; margin: 0; }
:root {
  --bg-color: #120f18;
  --surface-bg: #1b1624;
  --surface-bg-2: #221a2f;
  --border-color: #342a46;
  --accent-color: #a779ff;
  --text-color: #ece8f5;
  --text-muted: #9a8eb3;
}

html, body {
  max-width: 100vw;
  overflow: hidden;
  font-family: "Segoe UI", "Microsoft YaHei", sans-serif;
  color: var(--text-color);
  background: var(--bg-color);
}

#root {
  height: 100vh;
  width: 100vw;
}

a { color: inherit; text-decoration: none; }
`, "",{"version":3,"sources":["webpack://./app/index.css"],"names":[],"mappings":"AAAA,IAAI,sBAAsB,EAAE,UAAU,EAAE,SAAS,EAAE;AACnD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sDAAsD;EACtD,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,IAAI,cAAc,EAAE,qBAAqB,EAAE","sourcesContent":["* { box-sizing: border-box; padding: 0; margin: 0; }\r\n:root {\r\n  --bg-color: #120f18;\r\n  --surface-bg: #1b1624;\r\n  --surface-bg-2: #221a2f;\r\n  --border-color: #342a46;\r\n  --accent-color: #a779ff;\r\n  --text-color: #ece8f5;\r\n  --text-muted: #9a8eb3;\r\n}\r\n\r\nhtml, body {\r\n  max-width: 100vw;\r\n  overflow: hidden;\r\n  font-family: \"Segoe UI\", \"Microsoft YaHei\", sans-serif;\r\n  color: var(--text-color);\r\n  background: var(--bg-color);\r\n}\r\n\r\n#root {\r\n  height: 100vh;\r\n  width: 100vw;\r\n}\r\n\r\na { color: inherit; text-decoration: none; }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
